(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mb-cord-length"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mb-cord-length')) {
    customElements.define('mb-cord-length', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.form = this.closest('form');
        if (!this.input || !this.form) return;
        this.updateCheckout = () => {
          const blocked = !this.input.checkValidity();
          this.form.querySelectorAll('.mb-cord-checkout').forEach((checkout) => {
            checkout.inert = blocked;
            checkout.setAttribute('aria-disabled', String(blocked));
          });
        };
        this.input.addEventListener('input', this.updateCheckout);
        this.observer = new MutationObserver(this.updateCheckout);
        this.observer.observe(this.form, { childList: true, subtree: true });
        this.updateCheckout();
      }
      disconnectedCallback() {
        this.input?.removeEventListener('input', this.updateCheckout);
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-loop-film"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mb-loop-film'))customElements.define('mb-loop-film',class extends HTMLElement{
connectedCallback(){if(this.video)return;this.video=this.querySelector('video');this.video.muted=true;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.onVisibility=()=>this.update();this.onMotion=()=>this.update();this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update()},{threshold:.15});this.observer.observe(this);document.addEventListener('visibilitychange',this.onVisibility);this.motion.addEventListener('change',this.onMotion)}
update(){if(!this.video)return;if(!this.visible||document.hidden||this.motion.matches){this.video.pause();return}if(!this.loaded){this.video.querySelectorAll('source[data-src]').forEach(s=>s.src=s.dataset.src);this.video.load();this.loaded=true}this.video.play().catch(()=>{})}
disconnectedCallback(){this.observer?.disconnect();document.removeEventListener('visibilitychange',this.onVisibility);this.motion?.removeEventListener('change',this.onMotion);this.video?.pause();this.video=null;this.loaded=false}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-order-more"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('.mb-more-details') || !details.open) return;
    const wrapper = details.closest('[data-more-request]');
    const scope = wrapper.closest('product-info') || wrapper.closest('section');
    if (!scope) return;
    const variantId = scope.querySelector('product-form input[name="id"]')?.value;
    const variants = wrapper.querySelector('[data-more-variants]');
    const preferred = wrapper.querySelector('[data-more-option]');
    const option = variants ? Array.from(variants.options).find(item => item.value === variantId) : null;
    if (preferred && option && (!preferred.dataset.initialized || preferred.value === preferred.dataset.prefill)) {
      preferred.value = option.textContent.trim();
      preferred.dataset.prefill = preferred.value;
      preferred.dataset.initialized = 'true';
    }
    const quantity = wrapper.querySelector('[data-more-quantity]');
    const productQuantity = scope.querySelector('.quantity__input')?.value;
    if (quantity && !quantity.value && Number(productQuantity) > 1) quantity.value = productQuantity;
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-photo-carousel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mb-photo-carousel')){customElements.define('mb-photo-carousel',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('.mb-photo-carousel__track');this.slides=Array.from(this.querySelectorAll('.mb-photo-carousel__slide'));this.dots=Array.from(this.querySelectorAll('[data-slide]'));this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches||this.dataset.autoplay!=='true';this.interval=Number(this.dataset.interval)||5200;this.addEventListener('click',e=>{const b=e.target.closest('button');if(b&&b.hasAttribute('data-slide'))this.show(Number(b.dataset.slide));this.restart()});this.addEventListener('mouseenter',()=>this.stop());this.addEventListener('mouseleave',()=>this.restart());this.addEventListener('focusin',()=>this.stop());this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget))this.restart()});this.observer=new IntersectionObserver(es=>{this.inView=es[0].isIntersecting;if(this.inView)this.restart();else this.stop()},{threshold:.2});this.observer.observe(this);this.show(0)}show(next){this.index=(next+this.slides.length)%this.slides.length;this.track.style.transform=`translateX(-${this.index*100}%)`;this.slides.forEach((slide,i)=>slide.setAttribute('aria-hidden',String(i!==this.index)));this.dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===this.index)))}stop(){clearInterval(this.timer)}restart(){this.stop();if(!this.paused&&this.inView&&!(matchMedia('(hover: hover)').matches&&this.matches(':hover'))&&!this.contains(document.activeElement)&&this.slides.length>1)this.timer=setInterval(()=>this.show(this.index+1),this.interval)}disconnectedCallback(){this.stop();this.observer?.disconnect();this.ready=false}})}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('mb-welcome');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const state = dialog.querySelector('[data-welcome-state]')?.dataset.welcomeState;
    const key = 'mb-welcome-dismissed-until-v1';
    let previousFocus;
    const remember = () => { try { localStorage.setItem(key,String(Date.now()+30*24*60*60*1000)); } catch {} };
    const open = () => { if (dialog.open) return; previousFocus = document.activeElement; dialog.showModal(); };
    const close = () => { remember(); dialog.close(); if (previousFocus instanceof HTMLElement) previousFocus.focus(); };
    dialog.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click',close));
    dialog.addEventListener('cancel',remember);
    dialog.addEventListener('click',event => { if (event.target !== dialog) return; const r=dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) close(); });
    if (state === 'success' || state === 'error') { if(state === 'success') { try { localStorage.setItem(key,String(Date.now()+365*24*60*60*1000)); } catch {} } open(); return; }
    if (window.location.hash === '#mb-welcome-preview') { open(); return; }
    if (window.Shopify?.designMode) return;
    try { if(Number(localStorage.getItem(key))>Date.now()) return; } catch {}
    window.setTimeout(open,5000);
  })();
  } catch(e) { console.error(e); }
})();

})();
